<template>
    <section class="sessao-coberturas">
        <div class="row">
            <div class="col-xs-12">
                <h3><icon name="bar-chart"></icon> Coberturas</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.new_property')}">
                    <label for="data.coverage.new_property">Valor de Novo</label>
                    <div class="input-group">
                        <label class="switch">
                        <input type="checkbox" name="data.coverage.new_property" v-model="coverage.new_property"><span class="slider round"></span><span class="absolute-no"></span></label>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.new_property')">{{ errors.first('data.coverage.new_property') }}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.assistance')}">
                    <label for="data.coverage.assistance">{{ assists.label }} <span class="text-danger">*</span></label>
                    <v-select 
                        :options="assists.options"
                        label="text"
                        :filterable="true"
                        :reduce="x => x.id"
                        name="data.coverage.assistance" 
                        :id="assists.id" 
                        :placeholder="assists.placeholder" 
                        v-validate="{ rules: { required: true } }" 
                        :data-vv-as="assists.label" 
                        v-model="coverage.assistance"
                        :key="coverage.assistance"
                        class="vueSelect"
                    >
                    <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                    </v-select>
                    <div class="error-message" v-if="errors.has('data.coverage.assistance')">{{ errors.first('data.coverage.assistance') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.sum')}">
                    <label for="data.coverage.sum">{{ funds.label }} <span class="text-danger">*</span></label>
                    <v-select 
                        :options="funds.options"
                        label="text"
                        :filterable="true"
                        :reduce="x => x.id"
                        name="data.coverage.sum" 
                        :id="funds.id" 
                        :placeholder="funds.placeholder" 
                        v-validate="{ rules: { required: true } }" 
                        :data-vv-as="funds.label" 
                        v-model="coverage.sum"
                        :key="coverage.sum"
                        class="vueSelect"
                    >
                        <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                    </v-select>
                    <div class="error-message" v-if="errors.has('data.coverage.sum')">{{ errors.first('data.coverage.sum') }}</div>
                </div>
            </div>
            <div :class="['BUILDING_CONTENT'].includes(coverage.sum) ? 'col-xs-12 col-md-2' : 'col-xs-12 col-md-4'" v-if="['BUILDING_CONTENT', 'BUILDING'].includes(coverage.sum)">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.building_value')}">
                    <label for="data.coverage.building_value">Valor do Edifício</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.building_value" id="data.coverage.building_value" data-vv-as="Valor edifício" v-money="money" v-model.lazy="coverage.building_value"/>
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-show="errors.has('data.coverage.building_value')">{{ errors.first('data.coverage.building_value') }}</div>
                </div>
            </div>
            <div :class="['BUILDING_CONTENT'].includes(coverage.sum) ? 'col-xs-12 col-md-2' : 'col-xs-12 col-md-4'" v-if="['BUILDING_CONTENT', 'CONTENT'].includes(coverage.sum)">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.content_value')}">
                    <label for="data.coverage.content_value">Valor do Conteúdo</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.content_value" id="data.coverage.content_value" data-vv-as="Valor conteúdo" v-money="money" v-model.lazy="coverage.content_value" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-show="errors.has('data.coverage.content_value')">{{ errors.first('data.coverage.content_value') }}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.basic')}">
                    <label for="data.coverage.basic">Básica (Incêndio, Raio, Explosão)</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.basic" id="data.coverage.basic" data-vv-as="Básica" v-money="money" v-model.lazy="coverage.basic"/>
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.basic')">{{ errors.first('data.coverage.basic') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.electrical_damages')}">
                    <label for="data.coverage.electrical_damages">Danos elétricos</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.electrical_damages" id="data.coverage.electrical_damages" data-vv-as="Danos elétricos" v-money="money" v-model.lazy="coverage.electrical_damages" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.electrical_damages')">{{ errors.first('data.coverage.electrical_damages') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.glasses')}">
                    <label for="data.coverage.glasses">Vidros</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.glasses" id="data.coverage.glasses" data-vv-as="Vidros" v-money="money" v-model.lazy="coverage.glasses" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.glasses')">{{ errors.first('data.coverage.glasses') }}</div>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.theft_goods')}">
                    <label for="data.coverage.theft_goods">Roubos de Bens</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.theft_goods" id="data.coverage.theft_goods" data-vv-as="Roubos de Bens" v-money="money" v-model.lazy="coverage.theft_goods" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.theft_goods')">{{ errors.first('data.coverage.theft_goods') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.theft_values')}">
                    <label for="data.coverage.theft_values">Roubo de Valores</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.theft_values" id="data.coverage.theft_values" data-vv-as="Roubo de Valores" v-money="money" v-model.lazy="coverage.theft_values" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.theft_values')">{{ errors.first('data.coverage.theft_values') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.equipments')}">
                    <label for="data.coverage.equipments">Equipamentos</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.equipments" id="data.coverage.equipments" data-vv-as="Equipamentos" v-money="money" v-model.lazy="coverage.equipments" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.equipments')">{{ errors.first('data.coverage.equipments') }}</div>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.wind')}">
                    <label for="data.coverage.wind">Vendaval</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.wind" id="data.coverage.wind" data-vv-as="Vendaval" v-money="money" v-model.lazy="coverage.wind" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.wind')">{{ errors.first('data.coverage.wind') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.vehicle_impact')}">
                    <label for="data.coverage.vehicle_impact">Impacto de veículos</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.vehicle_impact" id="data.coverage.vehicle_impact" data-vv-as="Impacto de veículos" v-money="money" v-model.lazy="coverage.vehicle_impact" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.vehicle_impact')">{{ errors.first('data.coverage.vehicle_impact') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.landslip')}">
                    <label for="data.coverage.landslip">Desmoronamento</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.landslip" id="covdata[coverage][landslip]erage_landslip" data-vv-as="Desmoronamento" v-money="money" v-model.lazy="coverage.landslip" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.landslip')">{{ errors.first('data.coverage.landslip') }}</div>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.adverts')}">
                    <label for="data.coverage.adverts">Anúncios/Letreiros</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.adverts" id="data.coverage.adverts" data-vv-as="Anúncios/Letreiros" v-money="money" v-model.lazy="coverage.adverts" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.adverts')">{{ errors.first('data.coverage.adverts') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.rent_payment')}">
                    <label for="data.coverage.rent_payment">Aluguel</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.rent_payment" id="coverage_rent_payment" data-vv-as="Aluguel" v-money="money" v-model.lazy="coverage.rent_payment" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.rent_payment')">{{ errors.first('data.coverage.rent_payment') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.turmoil')}">
                    <label for="data.coverage.turmoil">Tumulto/Greve</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.turmoil" id="coverage_turmoil" data-vv-as="Tumulto/Greve" v-money="money" v-model.lazy="coverage.turmoil" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.turmoil')">{{ errors.first('data.coverage.turmoil') }}</div>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.recomposition_documents')}">
                    <label for="data.coverage.recomposition_documents">Rec. Documentos</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.recomposition_documents" id="data.coverage.recomposition_documents" data-vv-as="Rec. Documentos" v-money="money" v-model.lazy="coverage.recomposition_documents" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.recomposition_documents')">{{ errors.first('data.coverage.recomposition_documents') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.liability_operations')}">
                    <label for="data.coverage.liability_operations">RC Operações</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.liability_operations" id="data.coverage.liability_operations" data-vv-as="RC Operações" v-money="money" v-model.lazy="coverage.liability_operations" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.liability_operations')">{{ errors.first('data.coverage.liability_operations') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.liability_employer')}">
                    <label for="data.coverage.liability_employer">RC Empregador</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.liability_employer" id="data.coverage.liability_employer" data-vv-as="RC Empregador" v-money="money" v-model.lazy="coverage.liability_employer" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.liability_employer')">{{ errors.first('data.coverage.liability_employer') }}</div>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.moral_damages')}">
                    <label for="data.coverage.moral_damages">Danos Morais</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.moral_damages" id="data.coverage.moral_damages" data-vv-as="Danos Morais" v-money="money" v-model.lazy="coverage.moral_damages" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.moral_damages')">{{ errors.first('data.coverage.moral_damages') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.fixed_expenses')}">
                    <label for="data.coverage.fixed_expenses">Despesas Fixas</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.fixed_expenses" id="data.coverage.fixed_expenses" data-vv-as="Despesas Fixas" v-money="money" v-model.lazy="coverage.fixed_expenses" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.fixed_expenses')">{{ errors.first('data.coverage.fixed_expenses') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.business_interruption')}">
                    <label for="data.coverage.business_interruption">Lucros Cessantes</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.business_interruption" id="data.coverage.business_interruption" data-vv-as="Lucros Cessantes" v-money="money" v-model.lazy="coverage.business_interruption" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-if="errors.has('data.coverage.business_interruption')">{{ errors.first('data.coverage.business_interruption') }}</div>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.leaks')}">
                    <label for="data.coverage.leaks">Vazamentos</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.leaks" id="data.coverage.leaks" data-vv-as="Vazamentos" v-money="money" v-model.lazy="coverage.leaks" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-show="errors.has('data.coverage.leaks')">{{ errors.first('data.coverage.leaks') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.shower')}">
                    <label for="data.coverage.shower">Chuveiro/Sprinkler</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.shower" id="data.coverage.shower" data-vv-as="Chuveiro/Sprinkler" v-money="money" v-model.lazy="coverage.shower" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-show="errors.has('data.coverage.shower')">{{ errors.first('data.coverage.shower') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.coverage.loyalty')}">
                    <label for="data.coverage.loyalty">Fidelidade</label>
                    <div class="input-group">
                        <span class="input-group-addon">R$</span>
                        <input class="form-control" name="data.coverage.loyalty" id="data.coverage.loyalty" data-vv-as="Fidelidade" v-money="money" v-model.lazy="coverage.loyalty" />
                        <span class="input-group-addon">,00</span>
                    </div>
                    <div class="error-message" v-show="errors.has('data.coverage.loyalty')">{{ errors.first('data[coverage][loyalty]') }}</div>
                </div>
            </div>
        </div><!-- end row -->
    </section>
</template>

<script>
    import FormHelp from 'shared/modules/Help/FormHelp.vue'
    import Select2 from 'shared/modules/Select2/Select2.vue'
    import { VMoney } from 'v-money'

    export default {
        components: {
            FormHelp,
            Select2
        },
        directives: {
            money: VMoney
        },
        props: {coverage:Object},
        data(){
            return {
                    money: {
                        decimal: ',',
                        thousands: '.',
                        prefix: '',
                        suffix: '',
                        precision: 0,
                        masked: false
                    },
                    assists: {
                        disabled: true,
                        name: 'data.coverage.assistance',
                        label: 'Assistência',
                        placeholder: 'Carregando...',
                        options: []
                    },
                    funds: {
                        disabled: true,
                        name: 'data.coverage.sum',
                        label: 'Verba',
                        placeholder: 'Carregando...',
                        options: []
                    }
            }
        },
        computed: {
            quotation(){
                return this.$store.getters['quotation']
            },
        },
        mounted() {
            this.initVerbas()
            this.initAssistencias()
        },
        watch: {
               quotation(quotation){
                if( ! quotation.data.data.coverage )
                    return

                if( quotation.data.data.coverage.new_property )
                    this.coverage.new_property = quotation.data.data.coverage.new_property

                if( quotation.data.data.coverage.assistance )
                    this.coverage.assistance = quotation.data.data.coverage.assistance

                if( quotation.data.data.coverage.sum )
                    this.coverage.sum = quotation.data.data.coverage.sum
                
                if( quotation.data.data.coverage.building_value )
                    this.coverage.building_value = quotation.data.data.coverage.building_value

                if( quotation.data.data.coverage.content_value )
                    this.coverage.content_value = quotation.data.data.coverage.content_value

                if( quotation.data.data.coverage.basic )
                    this.coverage.basic = quotation.data.data.coverage.basic

                if( quotation.data.data.coverage.electrical_damages )
                    this.coverage.electrical_damages = quotation.data.data.coverage.electrical_damages

                if( quotation.data.data.coverage.glasses )
                    this.coverage.glasses = quotation.data.data.coverage.glasses

                if( quotation.data.data.coverage.theft_goods )
                    this.coverage.theft_goods = quotation.data.data.coverage.theft_goods

                if( quotation.data.data.coverage.theft_values )
                    this.coverage.theft_values = quotation.data.data.coverage.theft_values

                if( quotation.data.data.coverage.equipments )
                    this.coverage.equipments = quotation.data.data.coverage.equipments

                if( quotation.data.data.coverage.wind )
                    this.coverage.wind = quotation.data.data.coverage.wind

                if( quotation.data.data.coverage.vehicle_impact )
                    this.coverage.vehicle_impact = quotation.data.data.coverage.vehicle_impact

                if( quotation.data.data.coverage.landslip )
                    this.coverage.landslip = quotation.data.data.coverage.landslip

                if( quotation.data.data.coverage.adverts )
                    this.coverage.adverts = quotation.data.data.coverage.adverts

                if( quotation.data.data.coverage.rent_payment )
                    this.coverage.rent_payment = quotation.data.data.coverage.rent_payment

                if( quotation.data.data.coverage.turmoil )
                    this.coverage.turmoil = quotation.data.data.coverage.turmoil

                if( quotation.data.data.coverage.recomposition_documents )
                    this.coverage.recomposition_documents = quotation.data.data.coverage.recomposition_documents

                if( quotation.data.data.coverage.liability_operations )
                    this.coverage.liability_operations = quotation.data.data.coverage.liability_operations

                if( quotation.data.data.coverage.liability_employer )
                    this.coverage.liability_employer = quotation.data.data.coverage.liability_employer

                if( quotation.data.data.coverage.moral_damages )
                    this.coverage.moral_damages = quotation.data.data.coverage.moral_damages

                if( quotation.data.data.coverage.fixed_expenses )
                    this.coverage.fixed_expenses = quotation.data.data.coverage.fixed_expenses

                if( quotation.data.data.coverage.business_interruption )
                    this.coverage.business_interruption = quotation.data.data.coverage.business_interruption

                if( quotation.data.data.coverage.leaks )
                    this.coverage.leaks = quotation.data.data.coverage.leaks

                if( quotation.data.data.coverage.shower )
                    this.coverage.shower = quotation.data.data.coverage.shower

                if( quotation.data.data.coverage.loyalty )
                    this.coverage.loyalty = quotation.data.data.coverage.loyalty
            }
        },
        methods: {    
            initAssistencias(){
                this.assists.placeholder = '- Selecione -'
                this.assists.disabled    = false
                this.assists.options = [{
                                                    id: "BASIC",
                                                    text: "Básica"
                                                }, 
                                                {
                                                    id: "TOTAL",
                                                    text: "Total"
                                                }, 
                                                {
                                                    id: "INTERMEDIARY",
                                                    text: "Intermediária"
                                                }]

            },
            initVerbas(){
                this.funds.placeholder = '- Selecione -'
                this.funds.disabled    = false
                this.funds.options = [{
                                                    id: "CONTENT",
                                                    text: "Somente conteúdo"
                                                }, 
                                                {
                                                    id: "BUILDING",
                                                    text: "Somente edifício"
                                                }, 
                                                {
                                                    id: "BUILDING_CONTENT",
                                                    text: "Edifício + conteúdo"
                                                }]

            }
        }
    }
</script>


// WEBPACK FOOTER //
// FormPartialCoverage.vue?967f593e